
<template lang="html">
  <div class="user-referral-list--inner">
    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedType"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="confirmed"
            name="confirmed"
          >
            <span>confirmed</span>
          </select-option>

          <select-option
            value="rejected"
            name="rejected"
          >
            <span>rejected</span>
          </select-option>

          <select-option
            value="banned"
            name="ban"
          >
            <span>banned</span>
          </select-option>

          <select-option
            value="waiting"
            name="waiting"
          >
            <span>waiting</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          title="save"
          @click="update()"
          v-if="selected.length > 0"
        >
          <i class="ico--save"></i>
        </button>

        <button
          class="btn--modify"
          v-if="selected.length > 0"
          @click="updateStatus('C')"
        >
          <span>confirm</span>
        </button>

        <button
          class="btn--delete"
          v-if="selected.length > 0"
          @click="updateStatus('R')"
        >
          <span>reject</span>
        </button>
      </div>
    </div>
    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner v-if="!isDataLoading">
        <tbl-head>
          <tbl-row>

            <tbl-td name="checkbox">
              <checkbox>
                <input
                  type="checkbox"
                  @click="checkAll(referrals)"
                  :checked="selectAll"
                />
              </checkbox>
            </tbl-td>

            <tbl-td
              name="no"
              :sort="true"
              @click.native="sort('id')"
            >
              no
            </tbl-td>

            <tbl-td
              name="date"
              :sort="true"
              @click.native="sort('created_at')"
            >
              created-at
            </tbl-td>

            <tbl-td name="code">
              code
            </tbl-td>

            <tbl-td name="agent">
              agent
            </tbl-td>

            <tbl-td
              name="login-id"
              :sort="true"
              @click.native="sort('login_id')"
            >
              login  id
            </tbl-td>

            <tbl-td
              name="login-name"
              :sort="true"
              @click.native="sort('login_name')"
            >
              login  name
            </tbl-td>

            <tbl-td
              name="status"
              :sort="true"
              @click.native="sort('status')"
            >
              status
            </tbl-td>

            <tbl-td
              name="balance"
              :sort="true"
              @click.native="sort('amount')"
            >
              balance
            </tbl-td>

            <tbl-td
              name="point"
              :sort="true"
              @click.native="sort('point')"
            >
              point
            </tbl-td>

            <tbl-td
              name="total-bet"
              :sort="true"
              @click.native="sort('total_bet')"
            >
              total  bet
            </tbl-td>

            <tbl-td
              name="total-win"
              :sort="true"
              @click.native="sort('total_win')"
            >
              total win
            </tbl-td>

            <tbl-td
              name="total-net"
              :sort="true"
              @click.native="sort('total_net')"
            >
              total net
            </tbl-td>

          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="(item, i) in referrals"
            :key="i"
            :class="{'is-deleted': item.deleted_at}"
          >
            <tbl-td name="checkbox">
              <checkbox>
                <input
                  type="checkbox"
                  v-model="selected"
                  :value="item.id"
                />
              </checkbox>
            </tbl-td>

            <tbl-td name="no">
              {{ generateNumber(i, params.page, params.rows, params.sort, refCount || 0) }}
            </tbl-td>

            <tbl-td name="date">
              {{item.created_at | date}}
            </tbl-td>

            <tbl-td name="code">
              {{item.code.code}}
            </tbl-td>

            <tbl-td name="admin-ip">
              {{item.code.agent_id}}
            </tbl-td>

            <tbl-td
              name="login-id"
              @click.native="openUser(item.id, 'info')"
            >
              {{item.login_id}}
            </tbl-td>

            <tbl-td
              name="login-name"
              @click.native="openUser(item.id, 'bet-history/all')"
            >
              {{item.login_name}}
            </tbl-td>

            <tbl-td name="status">
            <!--   <select v-if="!item.deleted_at && checkPermission">
                <option
                  v-for="(stat, x) in userStatus[item.id]"
                >
                  {{stat | status}}
                </option>
              </select> -->
              <select-list
                :title="item.status | status"
                :withReset="true"
                v-model="item.status"
                v-if="!item.deleted_at && checkPermission"
                @reset="resetTrigger(item)"
              >
                <select-option
                  v-for="(stat, x) in userStatus[item.id]"
                  :key="x"
                  :value="stat"
                  :name="stat | status"
                  @click.native="setSelected(item)"
                >
                  {{ stat | status }}
                </select-option>
              </select-list>
              <span v-else> {{ (!item.deleted_at ? item.status : 'd') | status }}</span>
            </tbl-td>

            <tbl-td
              name="balance"
              @click.native="openUser(item.id, 'cash-history/all')"
            >
              {{item.amount | FormatAmount}}
            </tbl-td>

            <tbl-td
              name="point"
              @click.native="openUser(item.id, 'point-history/all')"
            >
              {{item.point | FormatAmount}}
            </tbl-td>

            <tbl-td name="total-bet">
              {{item.total_bet | FormatAmount}}
            </tbl-td>

            <tbl-td name="total-win">
              {{item.total_win | FormatAmount}}
            </tbl-td>

            <tbl-td name="total-net">
              {{item.total_net | FormatAmount}}
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="refCount"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>
    </tbl>
  </div>
</template>

<script>
import { points, transfers } from '@/socket'
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'
import { swal } from '@/assets/js/mixins/base/Swal'

//= components
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import Pagination from '@/components/base/Pagination'
import CheckDataList from '@/components/base/CheckDataList'
import Checkbox from '@/components/base/Checkbox'

import '@/components/base/select/Select'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'user-referral-list',

  components: {
    Modal,
    Search,
    Pagination,
    CheckDataList,
    Checkbox
  },

  mixins: [
    getListStatus,
    checkAll,
    swal
  ],

  filters: {
    FormatAmount,

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  computed: {
    ...mapState('userReferral', ['referrals', 'refCount']),

    userStatus () {
      let status = {}

      this.referrals.forEach((e) => {
        switch (e.status.toLowerCase()) {
          case 'c':
            status[e.id] = ['P', 'W', 'B']
            break
          case 'w':
          case 'p':
            status[e.id] = ['C', 'R', 'W']
            break
          case 'b':
            status[e.id] = ['C']
            break
          case 'r':
            status[e.id] = ['P', 'W']
            break
        }
      })

      return status
    },

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  async created () {
    this.params = this.generate(this.params)
    this.search()

    points.on('manual', (data) => {
      data = JSON.parse(data)
      this.referrals.forEach((e) => {
        if (parseInt(data.user) === parseInt(e.id)) {
          e.point = parseInt(e.point) + parseInt(data.data.data)
        }
      })
      // this.search()
    })

    transfers.on('manual', (data) => {
      data = JSON.parse(data)

      this.referrals.forEach((e) => {
        if (parseInt(data.user) === parseInt(e.id)) {
          e.amount = parseInt(e.amount) + parseInt(data.data.amount)
        }
      })
    })
  },

  beforeDestroy () {
    points.removeListener('manual')
    transfers.removeListener('manual')
  },

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: '',
        date_by: ''
      },
      this.$route.query
    )

    return {
      params,

      selectAll: false,
      selected: [],

      isDataLoading: true,
      showDataLoading: false,
      isEmpty: false,

      selectedList: this.$route.params.subtype,

      filterBy: [
        {
          value: 'login_id',
          display: 'user name'
        },
        {
          value: 'agent',
          display: 'agent'
        },

        {
          value: 'code',
          display: 'code'
        },
        {
          value: 'amount',
          display: 'amount'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        }
      ],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      copy: []
    }
  },
  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      if($router.query.filter_by){
        this.search(this.generate($router.query))
      } else {
        this.search()
      }

    }
  },

  methods: {
    ...mapActions('userReferral', ['get']),
    ...mapActions('user', {
      createUsers: 'create',
      patch: 'update',
      getUsers: 'get',
      deleteUsers: 'delete'
    }),

    async search (query) {
      this.params = query || this.generate(this.params)
      console.log('user ref vue search ==>', this.params )
      this.params.rows = 20

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        id: this.$route.params.id,
        params: this.params,
        status: this.selectedType
      })

      this.copy = JSON.parse(JSON.stringify(this.referrals))
      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.referrals.length) {
        this.isEmpty = true
      }
    },
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    clear () {},

    setSelected (user) {
      this.$nextTick(() => {
        let result = this.copy.find((row) => {
          return row.id === user.id
        })

        let idx = this.selected.indexOf(user.id)

        if (user.level_id === result.level_id &&
            user.vip_id === result.vip_id &&
            user.status === result.status &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (user.level_id === result.level_id &&
          user.vip_id === result.vip_id &&
          user.status === result.status) {
          return
        }

        this.selected.push(user.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    resetTrigger (user) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(user.id)

        let result = this.copy.find((row) => {
          return row.id === user.id
        })

        if (result.level_id !== user.level_id) {
          count += 1
        }

        if (result.vip_id !== user.vip_id) {
          count += 1
        }

        if (result.status !== user.status) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    },

    async deleteData () {
      this.$alert('prompt', 'Are you sure you want to delete the following user(s)?', {}, async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.deleteUsers({ uid: this.selected[x] })
        }

        this.selectAll = false
        this.search()
      }, 'Delete User')
    },

    async restore () {
      this.$alert('prompt', 'Are you sure you want to restore the following user(s)?', {}, async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.patch({
            id: this.selected[x],
            data: {
              deleted_at: null
            }
          })
        }

        this.selectAll = false
        this.search()
      }, 'Restore User')
    },

    async update () {
      this.$alert('prompt', 'Are you sure you want to modify the following user(s)?', {}, async () => {
        let keys = ['login_id', 'login_name', 'email', 'level_id', 'vip_id', 'status']
        let memo = ''

        this.showDataLoading = true

        let edited = this.referrals.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < edited.length; x++) {
          let data = {}

          for (var key in edited[x]) {
            if (keys.indexOf(key) > -1) {
              data[key] = edited[x][key]
            } // end if
          } // end for

          try {
            await this.patch({ data: data, id: edited[x].id })
            this.createLog({ action: 'updated', origin: 'users' })
            if (edited[x].memo) {
              await this.createMemo({ memo: edited[x].memo, id: edited[x].id })
              this.createLog({ action: 'insert', origin: 'users memo' })
            }
          } catch (err) {

          }
        } // end for

        this.selectAll = false
        this.showDataLoading = false
        this.search()
        this.getAllMeta()

        if (!this.users.length) {
          this.isEmpty = true
        }
      }, 'Modify User')
    },

    updateStatus (status) {
      this.referrals.forEach((e) => {
        if (this.selected.indexOf(e.id) > -1) {
          e.status = status
        }
      })

      this.update()
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }

}
</script>
